export enum FileScanStatus {
    UNSCANNED = 'unscanned',
    CLEAN = 'clean',
    QUARANTINED = 'quarantined',
    ERROR = 'error',
}
